export enum StreamState {
    PreStreamLobby ='PreStreamLobby',
    InitialCountdown ='InitialCountdown',
    InProgress ='InProgress',
    AfterEpisodeLobby ='AfterEpisodeLobby',
    StreamIsOver = 'StreamIsOver',
    HostLeftStream = 'HostLeftStream',
}
